import Vue from "vue";
import VueQrcodeReader from "vue-qrcode-reader";
import Notifications from "vue-notification";

import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./config/fa.config";

Vue.config.productionTip = false;

Vue.use(VueQrcodeReader);
Vue.use(Notifications);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
